<template>
    <div class="container">
        <div class="row">
            <div class="degree-list" v-if="seriousness!=0 || positive!=0 || progress!=0 ">
                <div class="degree-item" v-if="seriousness != 0">
                    <span class="degree-name">认真程度</span>
                    <Star :num="seriousness"></Star>
                </div>
                <div class="degree-item" v-if="positive != 0">
                    <span class="degree-name">积极程度</span>
                    <Star :num="positive"></Star>
                </div>
                <div class="degree-item" v-if="progress != 0">
                    <span class="degree-name">进步程度</span>
                    <Star :num="progress"></Star>
                </div>
            </div>
            <div class="medal" v-if="level != 0">
                <Medal :value="level"/>
            </div>
        </div>
        <div class="speech-evaluation" v-if="VoiceUrl">
            <SpeechEvaluation imgUrl="" :VoiceUrl="VoiceUrl" :time="time"></SpeechEvaluation>
        </div>
    </div>
</template>

<script>
    import Medal from './Medal.vue'
    import SpeechEvaluation from './SpeechEvaluation.vue'
    import Star from './Star.vue'
    export default {
        props: ['seriousness', 'positive', 'progress', 'level', 'VoiceUrl', 'time'],
        components: {
            Medal,
            SpeechEvaluation,
            Star
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/styles/variable";

    .container {
        padding: 20px;
        position: relative;
        .row {
            display: flex;
            justify-content: center;
            margin-bottom: 27px;
            .degree-list {
                width: 233px;
                .degree-item {
                    line-height: 32px;
                    overflow: hidden;
                    .degree-name {
                        font-size: $font-size-medium;
                        color: $color-text-grey;
                        float: left;
                        margin-right: 7px;
                    }
                }
            }
        }
        .medal {
            width: 82px;
            height: 82px;
        }
    }

    .speech-evaluation {
        margin-bottom: 10px;
    }

</style>



// WEBPACK FOOTER //
// src/components/Evaluate.vue